msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: ca\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-08-27 08:36\n"
"Last-Translator: \n"
"Language-Team: Catalan\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: ca\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:133
msgid "Locked"
msgstr "Blocada"

#: src/components/account-block.jsx:139
msgid "Posts: {0}"
msgstr "Publicacions: {0}"

#: src/components/account-block.jsx:144
msgid "Last posted: {0}"
msgstr "Última publicació: {0}"

#: src/components/account-block.jsx:159
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Automatitzat"

#: src/components/account-block.jsx:166
#: src/components/account-info.jsx:639
#: src/components/status.jsx:439
#: src/pages/catchup.jsx:1438
msgid "Group"
msgstr "Grup"

#: src/components/account-block.jsx:176
msgid "Mutual"
msgstr "Mutu"

#: src/components/account-block.jsx:180
#: src/components/account-info.jsx:1674
msgid "Requested"
msgstr "Sol·licitat per"

#: src/components/account-block.jsx:184
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:756
#: src/components/account-info.jsx:1665
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:137
#: src/pages/following.jsx:20
#: src/pages/following.jsx:131
msgid "Following"
msgstr "Seguint-ne"

#: src/components/account-block.jsx:188
#: src/components/account-info.jsx:1059
msgid "Follows you"
msgstr "Et segueix"

#: src/components/account-block.jsx:196
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount , plural, one {# seguidor} other {# seguidors}}"

#: src/components/account-block.jsx:205
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Verificada"

#: src/components/account-block.jsx:220
#: src/components/account-info.jsx:777
msgid "Joined <0>{0}</0>"
msgstr "S'hi va unir <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Per sempre"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "No es pot carregar el compte."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Ves a la pàgina del compte"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Seguidors"

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:773
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "Publicacions"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1115
#: src/components/compose.jsx:2451
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1635
#: src/components/status.jsx:1652
#: src/components/status.jsx:1776
#: src/components/status.jsx:2371
#: src/components/status.jsx:2374
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1169
#: src/pages/trending.jsx:437
msgid "More"
msgstr "Més"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> ha indicat que té un nou compte:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1273
msgid "Handle copied"
msgstr "Identificador copiat"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1276
msgid "Unable to copy handle"
msgstr "No ha sigut possible copiar l'identificador d'usuari"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1282
msgid "Copy handle"
msgstr "Copia l'identificador d'usuari"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Ves a la pàgina del perfil original"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Veure imatge de perfil"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Veure imatge de la capçalera"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "En Memòria"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:747
msgid "This user has chosen to not make this information available."
msgstr "Aquest usuari ha decidit no mostrar aquesta informació."

#: src/components/account-info.jsx:802
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} publicacions originals, {1} respostes, {2} impulsos"

#: src/components/account-info.jsx:818
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Última publicació en el darrer dia} other {Última publicació en els darrers {2} dies}}} other {{3, plural, one {Últimes {4} publicacions en el darrer dia} other {Últimes {5} publicacions en els darrers {6} dies}}}}"

#: src/components/account-info.jsx:831
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Última publicació en el darrer any(s)} other {Últimes {1} publicacions en el darrer any(s)}}"

#: src/components/account-info.jsx:855
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Original"

#: src/components/account-info.jsx:859
#: src/components/status.jsx:2162
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1412
#: src/pages/catchup.jsx:2023
#: src/pages/status.jsx:892
#: src/pages/status.jsx:1494
msgid "Replies"
msgstr "Respostes"

#: src/components/account-info.jsx:863
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1414
#: src/pages/catchup.jsx:2035
#: src/pages/settings.jsx:1028
msgid "Boosts"
msgstr "Impulsos"

#: src/components/account-info.jsx:869
msgid "Post stats unavailable."
msgstr "Les estadístiques de les publicacions no estan disponibles."

#: src/components/account-info.jsx:900
msgid "View post stats"
msgstr "Veure estadístiques de les publicacions"

#: src/components/account-info.jsx:1063
msgid "Last post: <0>{0}</0>"
msgstr "Última publicació: <0>{0}</0>"

#: src/components/account-info.jsx:1077
msgid "Muted"
msgstr "Usuaris silenciats"

#: src/components/account-info.jsx:1082
msgid "Blocked"
msgstr "Usuaris blocats"

#: src/components/account-info.jsx:1091
msgid "Private note"
msgstr "Nota privada"

#: src/components/account-info.jsx:1148
msgid "Mention <0>@{username}</0>"
msgstr "Menciona a <0>@{username}</0>"

#: src/components/account-info.jsx:1160
msgid "Translate bio"
msgstr "Tradueix la biografia"

#: src/components/account-info.jsx:1171
msgid "Edit private note"
msgstr "Edita una nota privada"

#: src/components/account-info.jsx:1171
msgid "Add private note"
msgstr "Afegiu una nota privada"

#: src/components/account-info.jsx:1191
msgid "Notifications enabled for @{username}'s posts."
msgstr "S'han activat les publicacions de @{username}."

#: src/components/account-info.jsx:1192
msgid "Notifications disabled for @{username}'s posts."
msgstr "S'han desactivat les publicacions de @{username}."

#: src/components/account-info.jsx:1204
msgid "Disable notifications"
msgstr "Desactiva les notificacions"

#: src/components/account-info.jsx:1205
msgid "Enable notifications"
msgstr "Activa les notificacions"

#: src/components/account-info.jsx:1222
msgid "Boosts from @{username} enabled."
msgstr "Impulsos de @{username} permesos."

#: src/components/account-info.jsx:1223
msgid "Boosts from @{username} disabled."
msgstr "Impulsos de @{username} inhabilitats."

#: src/components/account-info.jsx:1234
msgid "Disable boosts"
msgstr "Desactiva els impulsos"

#: src/components/account-info.jsx:1234
msgid "Enable boosts"
msgstr "Activa els impulsos"

#: src/components/account-info.jsx:1250
#: src/components/account-info.jsx:1260
#: src/components/account-info.jsx:1858
msgid "Add/Remove from Lists"
msgstr "Afegeix/elimina de les llistes"

#: src/components/account-info.jsx:1299
#: src/components/status.jsx:1078
msgid "Link copied"
msgstr "Enllaç copiat"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1081
msgid "Unable to copy link"
msgstr "No estat possible copiar l'enllaç"

#: src/components/account-info.jsx:1308
#: src/components/shortcuts-settings.jsx:1056
#: src/components/status.jsx:1087
#: src/components/status.jsx:3109
msgid "Copy"
msgstr "Copia"

#: src/components/account-info.jsx:1323
#: src/components/shortcuts-settings.jsx:1074
#: src/components/status.jsx:1103
msgid "Sharing doesn't seem to work."
msgstr "Sembla que la compartició no funciona."

#: src/components/account-info.jsx:1329
#: src/components/status.jsx:1109
msgid "Share…"
msgstr "Comparteix…"

#: src/components/account-info.jsx:1349
msgid "Unmuted @{username}"
msgstr "@{username} s'ha deixat de silenciar"

#: src/components/account-info.jsx:1361
msgid "Unmute <0>@{username}</0>"
msgstr "Deixa de silenciar a <0>@{username}</0>"

#: src/components/account-info.jsx:1377
msgid "Mute <0>@{username}</0>…"
msgstr "Silencia a <0>@{username}</0>…"

#: src/components/account-info.jsx:1409
msgid "Muted @{username} for {0}"
msgstr "@{username} silenciat durant {0}"

#: src/components/account-info.jsx:1421
msgid "Unable to mute @{username}"
msgstr "No ha estat possible silenciar @{username}"

#: src/components/account-info.jsx:1442
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Voleu suprimir a <0>@{username}</0> dels seguidors?"

#: src/components/account-info.jsx:1462
msgid "@{username} removed from followers"
msgstr "S'ha eliminat @{username} de la llista de seguidors"

#: src/components/account-info.jsx:1474
msgid "Remove follower…"
msgstr "Suprimeix seguidor…"

#: src/components/account-info.jsx:1485
msgid "Block <0>@{username}</0>?"
msgstr "Voleu blocar a <0>@{username}</0>?"

#: src/components/account-info.jsx:1506
msgid "Unblocked @{username}"
msgstr "S'ha desblocat a @{username}"

#: src/components/account-info.jsx:1514
msgid "Blocked @{username}"
msgstr "S'ha blocat a @{username}"

#: src/components/account-info.jsx:1522
msgid "Unable to unblock @{username}"
msgstr "No ha estat possible desblocar @{username}"

#: src/components/account-info.jsx:1524
msgid "Unable to block @{username}"
msgstr "No ha estat possible blocar @{username}"

#: src/components/account-info.jsx:1534
msgid "Unblock <0>@{username}</0>"
msgstr "Deixa de blocar a <0>@{username}</0>"

#: src/components/account-info.jsx:1543
msgid "Block <0>@{username}</0>…"
msgstr "Bloca a <0>@{username}</0>…"

#: src/components/account-info.jsx:1560
msgid "Report <0>@{username}</0>…"
msgstr "Denúncia a <0>@{username}</0>…"

#: src/components/account-info.jsx:1580
#: src/components/account-info.jsx:2091
msgid "Edit profile"
msgstr "Edita el perfil"

#: src/components/account-info.jsx:1616
msgid "Withdraw follow request?"
msgstr "Voleu retirar la sol·licitud de seguiment?"

#: src/components/account-info.jsx:1617
msgid "Unfollow @{0}?"
msgstr "Voleu deixar de seguir @{0}?"

#: src/components/account-info.jsx:1668
msgid "Unfollow…"
msgstr "Deixa de seguir…"

#: src/components/account-info.jsx:1677
msgid "Withdraw…"
msgstr "Descarta…"

#: src/components/account-info.jsx:1684
#: src/components/account-info.jsx:1688
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Segueix"

#: src/components/account-info.jsx:1799
#: src/components/account-info.jsx:1853
#: src/components/account-info.jsx:1986
#: src/components/account-info.jsx:2086
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:797
#: src/components/compose.jsx:2407
#: src/components/compose.jsx:2880
#: src/components/compose.jsx:3088
#: src/components/compose.jsx:3318
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:227
#: src/components/shortcuts-settings.jsx:580
#: src/components/shortcuts-settings.jsx:780
#: src/components/status.jsx:2834
#: src/components/status.jsx:3073
#: src/components/status.jsx:3571
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1548
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:840
#: src/pages/notifications.jsx:1054
#: src/pages/settings.jsx:69
#: src/pages/status.jsx:1256
msgid "Close"
msgstr "Tanca"

#: src/components/account-info.jsx:1804
msgid "Translated Bio"
msgstr "Biografia traduïda"

#: src/components/account-info.jsx:1898
msgid "Unable to remove from list."
msgstr "No s'ha pogut eliminar de la llista."

#: src/components/account-info.jsx:1899
msgid "Unable to add to list."
msgstr "No s'ha pogut afegir a la llista."

#: src/components/account-info.jsx:1918
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "No s'ha pogut carregar les llistes."

#: src/components/account-info.jsx:1922
msgid "No lists."
msgstr "No hi ha cap llista."

#: src/components/account-info.jsx:1933
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Llista nova"

#: src/components/account-info.jsx:1991
msgid "Private note about <0>@{0}</0>"
msgstr "Nota privada sobre <0>@{0}</0>"

#: src/components/account-info.jsx:2021
msgid "Unable to update private note."
msgstr "No ha estat possible actualitzar la nota privada."

#: src/components/account-info.jsx:2044
#: src/components/account-info.jsx:2214
msgid "Cancel"
msgstr "Cancel·la"

#: src/components/account-info.jsx:2049
msgid "Save & close"
msgstr "Desa i tanca"

#: src/components/account-info.jsx:2142
msgid "Unable to update profile."
msgstr "No ha estat possible actualitzar el perfil."

#: src/components/account-info.jsx:2162
msgid "Bio"
msgstr "Biografia"

#: src/components/account-info.jsx:2175
msgid "Extra fields"
msgstr "Camps addicionals"

#: src/components/account-info.jsx:2181
msgid "Label"
msgstr "Etiqueta"

#: src/components/account-info.jsx:2184
msgid "Content"
msgstr "Contingut"

#: src/components/account-info.jsx:2217
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:712
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:906
msgid "Save"
msgstr "Desa"

#: src/components/account-info.jsx:2270
msgid "username"
msgstr "nom d’usuari"

#: src/components/account-info.jsx:2274
msgid "server domain name"
msgstr "nom de domini del servidor"

#: src/components/background-service.jsx:138
msgid "Cloak mode disabled"
msgstr "Mode ocult desactivat"

#: src/components/background-service.jsx:138
msgid "Cloak mode enabled"
msgstr "Mode ocult activat"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:137
#: src/components/timeline.jsx:431
#: src/pages/catchup.jsx:860
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:52
#: src/pages/notifications.jsx:505
msgid "Home"
msgstr "Inici"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Redacta"

#: src/components/compose.jsx:392
msgid "You have unsaved changes. Discard this post?"
msgstr "Hi ha canvis sense desar. Voleu descartar la publicació?"

#: src/components/compose.jsx:614
#: src/components/compose.jsx:630
#: src/components/compose.jsx:1328
#: src/components/compose.jsx:1589
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Només podeu adjuntar com a màxim 1 fitxer.} other {Només podeu adjuntar un màxim de # fitxers.}}"

#: src/components/compose.jsx:778
msgid "Pop out"
msgstr "Finestra emergent"

#: src/components/compose.jsx:785
msgid "Minimize"
msgstr "Minimitza"

#: src/components/compose.jsx:821
msgid "Looks like you closed the parent window."
msgstr "Sembla que heu tancat la finestra principal."

#: src/components/compose.jsx:828
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Sembla que ja teniu un camp d'edició obert a la finestra principal i que esteu publicant. Espereu que es publiqui i torneu-ho a provar més tard."

#: src/components/compose.jsx:833
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Sembla que ja teniu un camp d'edició obert a la finestra principal. Si l'utilitzeu en aquesta finestra, es descartaran els canvis que heu fet a la finestra principal. Voleu continuar?"

#: src/components/compose.jsx:875
msgid "Pop in"
msgstr "Mostra"

#: src/components/compose.jsx:885
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Contestant la publicació de @{0} (<0>{1}</0>)"

#: src/components/compose.jsx:895
msgid "Replying to @{0}’s post"
msgstr "En resposta a la publicació de @{0}"

#: src/components/compose.jsx:908
msgid "Editing source post"
msgstr "Editant la publicació original"

#: src/components/compose.jsx:955
msgid "Poll must have at least 2 options"
msgstr "L'enquesta ha de tenir si més no 2 opcions"

#: src/components/compose.jsx:959
msgid "Some poll choices are empty"
msgstr "Alguna opció de l'enquesta és buida"

#: src/components/compose.jsx:972
msgid "Some media have no descriptions. Continue?"
msgstr "Alguns mitjans no tenen descripcions. Voleu continuar?"

#: src/components/compose.jsx:1024
msgid "Attachment #{i} failed"
msgstr "El fitxer adjunt #{i} ha fallat"

#: src/components/compose.jsx:1118
#: src/components/status.jsx:1961
#: src/components/timeline.jsx:975
msgid "Content warning"
msgstr "Avís de contingut"

#: src/components/compose.jsx:1134
msgid "Content warning or sensitive media"
msgstr "Advertiment de contingut o mitjans sensibles"

#: src/components/compose.jsx:1170
#: src/components/status.jsx:93
#: src/pages/settings.jsx:297
msgid "Public"
msgstr "Públic"

#: src/components/compose.jsx:1173
#: src/components/status.jsx:94
#: src/pages/settings.jsx:300
msgid "Unlisted"
msgstr "Sense llistar"

#: src/components/compose.jsx:1176
#: src/components/status.jsx:95
#: src/pages/settings.jsx:303
msgid "Followers only"
msgstr "Només per als seguidors"

#: src/components/compose.jsx:1179
#: src/components/status.jsx:96
#: src/components/status.jsx:1839
msgid "Private mention"
msgstr "Menció privada"

#: src/components/compose.jsx:1188
msgid "Post your reply"
msgstr "Publica la resposta"

#: src/components/compose.jsx:1190
msgid "Edit your post"
msgstr "Edita la publicació"

#: src/components/compose.jsx:1191
msgid "What are you doing?"
msgstr "Què feu ara?"

#: src/components/compose.jsx:1266
msgid "Mark media as sensitive"
msgstr "Marca els mitjans com a sensibles"

#: src/components/compose.jsx:1364
msgid "Add poll"
msgstr "Afegeix una enquesta"

#: src/components/compose.jsx:1386
msgid "Add custom emoji"
msgstr "Afegeix emoji personalitzat"

#: src/components/compose.jsx:1470
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:830
#: src/components/status.jsx:1615
#: src/components/status.jsx:1616
#: src/components/status.jsx:2267
msgid "Reply"
msgstr "Respon"

#: src/components/compose.jsx:1472
msgid "Update"
msgstr "Actualitza"

#: src/components/compose.jsx:1473
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Publica"

#: src/components/compose.jsx:1601
msgid "Downloading GIF…"
msgstr "S'està baixant el GIF…"

#: src/components/compose.jsx:1629
msgid "Failed to download GIF"
msgstr "Ha fallat la descàrrega del GIF"

#: src/components/compose.jsx:1740
#: src/components/compose.jsx:1817
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Més…"

#: src/components/compose.jsx:2220
msgid "Uploaded"
msgstr "Pujat"

#: src/components/compose.jsx:2233
msgid "Image description"
msgstr "Descripció de la imatge"

#: src/components/compose.jsx:2234
msgid "Video description"
msgstr "Descripció del vídeo"

#: src/components/compose.jsx:2235
msgid "Audio description"
msgstr "Descripció de l'àudio"

#: src/components/compose.jsx:2271
#: src/components/compose.jsx:2291
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "La mida del fitxer és massa gran. La càrrega pot tenir problemes. Proveu de reduir la mida del fitxer de {0} a {1} o inferior."

#: src/components/compose.jsx:2283
#: src/components/compose.jsx:2303
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "La resolució del fitxer és massa gran. La càrrega pot tenir problemes. Proveu de reduir la resolució de {0}×{1}px a {2}×{3}px."

#: src/components/compose.jsx:2311
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "La velocitat de fotogrames és massa alta. La càrrega pot tenir problemes."

#: src/components/compose.jsx:2371
#: src/components/compose.jsx:2621
#: src/components/shortcuts-settings.jsx:723
#: src/pages/catchup.jsx:1058
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Suprimeix"

#: src/components/compose.jsx:2388
#: src/compose.jsx:83
msgid "Error"
msgstr "Error"

#: src/components/compose.jsx:2413
msgid "Edit image description"
msgstr "Edita la descripció de la imatge"

#: src/components/compose.jsx:2414
msgid "Edit video description"
msgstr "Edita la descripció del vídeo"

#: src/components/compose.jsx:2415
msgid "Edit audio description"
msgstr "Edita la descripció de l'àudio"

#: src/components/compose.jsx:2460
#: src/components/compose.jsx:2509
msgid "Generating description. Please wait…"
msgstr "Generant descripció. Si us plau, espereu…"

#: src/components/compose.jsx:2480
msgid "Failed to generate description: {0}"
msgstr "No s'ha pogut generar la descripció: {0}"

#: src/components/compose.jsx:2481
msgid "Failed to generate description"
msgstr "No s'ha pogut generar la descripció"

#: src/components/compose.jsx:2493
#: src/components/compose.jsx:2499
#: src/components/compose.jsx:2545
msgid "Generate description…"
msgstr "Genera una descripció…"

#: src/components/compose.jsx:2532
msgid "Failed to generate description{0}"
msgstr "No s'ha pogut generar la descripció{0}"

#: src/components/compose.jsx:2547
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— experimental</0>"

#: src/components/compose.jsx:2566
msgid "Done"
msgstr "Fet"

#: src/components/compose.jsx:2602
msgid "Choice {0}"
msgstr "Opció {0}"

#: src/components/compose.jsx:2649
msgid "Multiple choices"
msgstr "Opció múltiple"

#: src/components/compose.jsx:2652
msgid "Duration"
msgstr "Durada"

#: src/components/compose.jsx:2683
msgid "Remove poll"
msgstr "Elimina l'enquesta"

#: src/components/compose.jsx:2897
msgid "Search accounts"
msgstr "Cerca comptes"

#: src/components/compose.jsx:2938
#: src/components/shortcuts-settings.jsx:712
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Afegeix"

#: src/components/compose.jsx:2951
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "S'ha produït un error en carregar els comptes"

#: src/components/compose.jsx:3094
msgid "Custom emojis"
msgstr "Emojis personalitzats"

#: src/components/compose.jsx:3114
msgid "Search emoji"
msgstr "Cerca emoji"

#: src/components/compose.jsx:3145
msgid "Error loading custom emojis"
msgstr "S'ha produït un error en carregar els emojis personalitzats"

#: src/components/compose.jsx:3156
msgid "Recently used"
msgstr "Usats recentment"

#: src/components/compose.jsx:3157
msgid "Others"
msgstr "Altres"

#: src/components/compose.jsx:3195
msgid "{0} more…"
msgstr "{0} més…"

#: src/components/compose.jsx:3333
msgid "Search GIFs"
msgstr "Cerca GIF"

#: src/components/compose.jsx:3348
msgid "Powered by GIPHY"
msgstr "Desenvolupat per GIPHY"

#: src/components/compose.jsx:3356
msgid "Type to search GIFs"
msgstr "Escriviu per cercar un GIF"

#: src/components/compose.jsx:3454
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:880
msgid "Previous"
msgstr "Anterior"

#: src/components/compose.jsx:3472
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:897
msgid "Next"
msgstr "Següent"

#: src/components/compose.jsx:3489
msgid "Error loading GIFs"
msgstr "S'ha produït un error en carregar els GIF"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:684
msgid "Unsent drafts"
msgstr "Esborranys no enviats"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Sembla que hi ha esborranys sense enviar. Continuarem on ho vau deixar."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Voleu suprimir aquesta esborrany?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Error quan desava l'esborrany. Torneu a intentar-ho."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1250
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Esborra…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "S'ha produït un error en obtenir l'estat de resposta!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Voleu suprimir tots els esborranys?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "S'ha produït un error en suprimir els esborranys! Si us plau, torna-ho a provar."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Elimina-ho tot…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "No s'han trobat esborranys."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1895
msgid "Poll"
msgstr "Enquesta"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Multimèdia"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Obre en una finestra nova"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:890
msgid "Accept"
msgstr "Accepta"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Rebutja"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1173
msgid "Accepted"
msgstr "Acceptat"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Rebutjat"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Res a mostrar"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:429
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "Comptes"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:513
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:820
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1289
msgid "Show more…"
msgstr "Mostra'n més…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:518
#: src/pages/search.jsx:459
msgid "The end."
msgstr "Final."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1586
msgid "Keyboard shortcuts"
msgstr "Dreceres de teclat"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Ajuda sobre dreceres de teclat"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1611
msgid "Next post"
msgstr "Publicació següent"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1619
msgid "Previous post"
msgstr "Publicació anterior"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Omet el carrusel a la següent publicació"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Omet el carrusel a l'anterior publicació"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Carrega publicacions noves"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1643
msgid "Open post details"
msgstr "Obre els detalls de la publicació"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enter</0> o bé <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Amplieu l'avís de contingut o<0/>canvia al fil ampliat/replegat"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Tanca la publicació o els diàlegs"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> o <1>Retrocés</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Centra la columna en mode de múltiples columnes"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> a <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "Redacta una publicació nova"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "Redacta una publicació nova (en una altra finestra)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "Envia la publicació"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> o <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:176
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "Cerca"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "Respon (en una altra finestra)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "M'agrada (favorit)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> o <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:838
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
#: src/components/status.jsx:2326
msgid "Boost"
msgstr "Impulsa"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:923
#: src/components/status.jsx:2350
#: src/components/status.jsx:2351
msgid "Bookmark"
msgstr "Afegeix als marcadors"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "Alterna el mode ocult"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Edita la llista"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "No s'ha pogut editar la llista."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "No s'ha pogut crear la llista."

#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Nom"

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Mostra les respostes dels membres de la llista"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Mostra les respostes de gent que segueixo"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "No mostris les respostes"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "Amaga les publicacions d'inici/seguint en aquesta llista"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Crea"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Voleu suprimir aquesta llista?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "No ha estat possible esborrar la llista."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Descripció dels mitjans"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:967
#: src/components/status.jsx:994
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Tradueix"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:981
#: src/components/status.jsx:1008
msgid "Speak"
msgstr "Pronuncia"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Obre el fitxer original en una finestra nova"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Obre el fitxer original"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Intentant descriure la imatge. Si us plau, espereu…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "No s'ha pogut descriure la imatge"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Descriu la imatge…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Mostra la publicació"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Contingut sensible"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Filtrat: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3401
#: src/components/status.jsx:3497
#: src/components/status.jsx:3575
#: src/components/timeline.jsx:964
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1843
msgid "Filtered"
msgstr "Filtrat"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Publicació enviada. Comproveu-la."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Resposta enviada. Comproveu-la."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Publicació actualitzada. Comproveu-la."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Menú"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Voleu tornar a carregar la pàgina per actualitzar-la?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Nova actualització disponible…"

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:855
msgid "Catch-up"
msgstr "Posada al dia"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:143
#: src/pages/home.jsx:223
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1020
#: src/pages/trending.jsx:347
msgid "Mentions"
msgstr "Mencions"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:149
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:83
#: src/pages/home.jsx:183
#: src/pages/notifications.jsx:106
#: src/pages/notifications.jsx:509
msgid "Notifications"
msgstr "Notificacions"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Nou"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Perfil"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:155
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Llistes"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Totes les llistes"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:192
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Marcadors"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:198
#: src/pages/catchup.jsx:1413
#: src/pages/catchup.jsx:2029
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1024
msgid "Likes"
msgstr "\"M'agrada\""

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Etiquetes seguides"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Filtres"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Usuaris silenciats"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Usuaris silenciats…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Usuaris blocats"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Usuaris blocats…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Comptes…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:166
#: src/pages/status.jsx:792
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Inicia sessió"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:169
#: src/pages/trending.jsx:407
msgid "Trending"
msgstr "Tendències"

#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:162
msgid "Local"
msgstr "Local"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:162
msgid "Federated"
msgstr "Federada"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Dreceres / Columnes…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Configuració…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Notificació"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Aquesta notificació és d'un altre compte vostre."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Mostra totes les notificacions"

#: src/components/notification.jsx:68
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} ha reaccionat a la vostra publicació \n"
"amb {emojiObject}"

#: src/components/notification.jsx:75
msgid "{account} published a post."
msgstr "{account} ha enviat una publicació."

#: src/components/notification.jsx:83
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} ha impulsat la teva resposta.} other {{account} ha impulsat la teva publicació.}}} other {{account} ha impulsat {postsCount} de les teves publicacions.}}} other {{postType, select, reply {<0><1>{0}</1> persones</0> han impulsat la teva resposta.} other {<2><3>{1}</3> persones</2> han impulsat la teva publicació.}}}}"

#: src/components/notification.jsx:126
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, one {}=1 {{account} et segueix.} other {<0><1>{0}</1> persones</0> et segueixen.}}"

#: src/components/notification.jsx:140
msgid "{account} requested to follow you."
msgstr "{account} ha enviat una sol·licitud de seguiment."

#: src/components/notification.jsx:149
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} li agrada la teva resposta.} other {{account} li agrada la teva publicació.}}} other {{account} li agrada {postsCount} de les teves publicacions.}}} other {{postType, select, reply {<0><1>{0}</1> persones</0> els agrada la teva resposta.} other {<2><3>{1}</3> persones</2> els agrada la teva publicació.}}}}"

#: src/components/notification.jsx:191
msgid "A poll you have voted in or created has ended."
msgstr "Ha finalitzat una enquesta vostra o en la qual heu participat."

#: src/components/notification.jsx:192
msgid "A poll you have created has ended."
msgstr "Ha finalitzat una enquesta vostra."

#: src/components/notification.jsx:193
msgid "A poll you have voted in has ended."
msgstr "Ha finalitzat una enquesta en què heu votat."

#: src/components/notification.jsx:194
msgid "A post you interacted with has been edited."
msgstr "Una publicació amb què heu interactuat ha estat editada."

#: src/components/notification.jsx:202
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} ha impulsat i li agrada la teva resposta.} other {{account} ha impulsat i li agrada la teva publicació.}}} other {{account} ha impulsat i li agrada {postsCount} de les teves publicacions.}}} other {{postType, select, reply {<0><1>{0}</1> persones</0> han impulsat i els agrada la teva resposta.} other {<2><3>{1}</3> persones</2> han impulsat i els agrada la teva publicació.}}}}"

#: src/components/notification.jsx:244
msgid "{account} signed up."
msgstr "{account} s'hi ha unit."

#: src/components/notification.jsx:246
msgid "{account} reported {targetAccount}"
msgstr "{account} ha denunciat a {targetAccount}"

#: src/components/notification.jsx:251
msgid "Lost connections with <0>{name}</0>."
msgstr "S'han perdut les connexions amb <0>{name}</0>."

#: src/components/notification.jsx:257
msgid "Moderation warning"
msgstr "Avís de moderació"

#: src/components/notification.jsx:267
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Un administrador de <0>{from}</0> ha suspès <1>{targetName}</1>; això vol dir que ja no en podreu rebre actualitzacions o interactuar-hi."

#: src/components/notification.jsx:273
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Un administrador de <0>{from}</0> ha blocat <1>{targetName}</1>. Seguidors afectats: {followersCount}, seguiments: {followingCount}."

#: src/components/notification.jsx:279
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Heu bloquejat a <0>{targetName}</0>. Seguidors eliminats: {followersCount}, seguidors: {followingCount}."

#: src/components/notification.jsx:287
msgid "Your account has received a moderation warning."
msgstr "El vostre compte ha rebut un avís de moderació."

#: src/components/notification.jsx:288
msgid "Your account has been disabled."
msgstr "S'ha desactivat el vostre compte."

#: src/components/notification.jsx:289
msgid "Some of your posts have been marked as sensitive."
msgstr "S'ha marcat com a sensibles algunes de les vostres publicacions."

#: src/components/notification.jsx:290
msgid "Some of your posts have been deleted."
msgstr "S'han eliminat algunes de les vostres publicacions."

#: src/components/notification.jsx:291
msgid "Your posts will be marked as sensitive from now on."
msgstr "A partir d'ara les vostres publicacions es marcaran com sensibles."

#: src/components/notification.jsx:292
msgid "Your account has been limited."
msgstr "S'ha limitat el vostre compte."

#: src/components/notification.jsx:293
msgid "Your account has been suspended."
msgstr "El vostre compte ha estat suspès."

#: src/components/notification.jsx:364
msgid "[Unknown notification type: {type}]"
msgstr "[Tipus de notificació desconeguda: {type}]"

#: src/components/notification.jsx:425
#: src/components/status.jsx:937
#: src/components/status.jsx:947
msgid "Boosted/Liked by…"
msgstr "Impulsat/Favorit per…"

#: src/components/notification.jsx:426
msgid "Liked by…"
msgstr "Li agrada a…"

#: src/components/notification.jsx:427
msgid "Boosted by…"
msgstr "Impulsat per…"

#: src/components/notification.jsx:428
msgid "Followed by…"
msgstr "Seguit per…"

#: src/components/notification.jsx:484
#: src/components/notification.jsx:500
msgid "Learn more <0/>"
msgstr "Saber-ne més <0/>"

#: src/components/notification.jsx:680
#: src/components/status.jsx:189
msgid "Read more →"
msgstr "Llegiu més →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Votat"

#: src/components/poll.jsx:135
#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Hide results"
msgstr "Amaga els resultats"

#: src/components/poll.jsx:184
msgid "Vote"
msgstr "Vota"

#: src/components/poll.jsx:204
#: src/components/poll.jsx:206
#: src/pages/status.jsx:1158
#: src/pages/status.jsx:1181
msgid "Refresh"
msgstr "Actualitza"

#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Show results"
msgstr "Mostra els resultats"

#: src/components/poll.jsx:227
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> vot} other {<1>{1}</1> vots}}"

#: src/components/poll.jsx:244
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> votant} other {<1>{1}</1> votants}}"

#: src/components/poll.jsx:264
msgid "Ended <0/>"
msgstr "Finalitzada<0/>"

#: src/components/poll.jsx:268
msgid "Ended"
msgstr "Finalitzada"

#: src/components/poll.jsx:271
msgid "Ending <0/>"
msgstr "Finalitza <0/>"

#: src/components/poll.jsx:275
msgid "Ending"
msgstr "Finalitza"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:55
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:60
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:65
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Brossa"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Enllaços maliciosos, interacció falsa o respostes repetitives"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Il·legal"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Viola la llei del vostre país o del país on és el servidor"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Incompliment d'alguna regla del servidor"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Viola regles específiques del servidor"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Violació"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Altres"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "El problema no encaixa en altres categories"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Denuncia la publicació"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Informar sobre @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Pendent de revisió"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Publicació denunciada"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Perfil denunciat"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "No ha estat possible denunciar la publicació"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "No ha estat possible denunciar el perfil"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Quin és el problema amb aquesta publicació?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Quin és el problema amb aquest perfil?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Informació addicional"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Reenvia a <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Envia informe"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Silencia a @{username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "No ha estat possible silenciar a {username}"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Envia l'informe <0>+ Silencia el perfil</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Bloca a {username}"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "No ha estat possible blocar a {username}"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Envia l'informe <0>+ Bloca el perfil</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ comptes, etiquetes i publicacions</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "Publicacions amb <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Publicacions etiquetades amb <0>#{0}</0>"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Cerca <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Comptes amb <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Inici / Seguint"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Públic (Local / Federat)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Compte"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Etiqueta"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "ID de llista"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Només local"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:170
msgid "Instance"
msgstr "Instància"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Opcional, p. ex. mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Cerca terme"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Opcional, tret que sigui per al mode de múltiples columnes"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "p. ex. PixelArt (màx. 5, separats per espais)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Només mèdia"

#: src/components/shortcuts-settings.jsx:232
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "Dreceres"

#: src/components/shortcuts-settings.jsx:240
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:246
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Especifiqueu una llista de dreceres que apareixeran com a:"

#: src/components/shortcuts-settings.jsx:252
msgid "Floating button"
msgstr "Botó flotant"

#: src/components/shortcuts-settings.jsx:257
msgid "Tab/Menu bar"
msgstr "Pestanya/Barra de menú"

#: src/components/shortcuts-settings.jsx:262
msgid "Multi-column"
msgstr "Múltiples columnes"

#: src/components/shortcuts-settings.jsx:329
msgid "Not available in current view mode"
msgstr "No disponible en el mode de visualització actual"

#: src/components/shortcuts-settings.jsx:348
msgid "Move up"
msgstr "Mou cap amunt"

#: src/components/shortcuts-settings.jsx:364
msgid "Move down"
msgstr "Mou cap avall"

#: src/components/shortcuts-settings.jsx:376
#: src/components/status.jsx:1215
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Edita"

#: src/components/shortcuts-settings.jsx:397
msgid "Add more than one shortcut/column to make this work."
msgstr "Afegiu més d'una drecera/columna perquè funcioni."

#: src/components/shortcuts-settings.jsx:408
msgid "No columns yet. Tap on the Add column button."
msgstr "No hi ha columnes encara. Toqueu el botó Afegeix columna."

#: src/components/shortcuts-settings.jsx:409
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "No hi ha dreceres encara. Toqueu el botó Afegeix drecera."

#: src/components/shortcuts-settings.jsx:412
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "No saps què afegir?<0/>Prova d'afegir primer <1>Pàgina d'Inici / Seguint i notificacions</1>."

#: src/components/shortcuts-settings.jsx:440
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Màxim {SHORTCUTS_LIMIT} columnes"

#: src/components/shortcuts-settings.jsx:441
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Màxim {SHORTCUTS_LIMIT} dreceres"

#: src/components/shortcuts-settings.jsx:455
msgid "Import/export"
msgstr "Importa/exporta"

#: src/components/shortcuts-settings.jsx:465
msgid "Add column…"
msgstr "Afegeix una columna…"

#: src/components/shortcuts-settings.jsx:466
msgid "Add shortcut…"
msgstr "Afegeix una drecera…"

#: src/components/shortcuts-settings.jsx:513
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "La llista específica és opcional. Per al mode de múltiples columnes, la llista és necessària, en cas contrari la columna no es mostrarà."

#: src/components/shortcuts-settings.jsx:514
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Per al mode de múltiples columnes, cal un terme de cerca, en cas contrari la columna no es mostrarà."

#: src/components/shortcuts-settings.jsx:515
msgid "Multiple hashtags are supported. Space-separated."
msgstr "S'admeten diverses etiquetes. Separades per espais."

#: src/components/shortcuts-settings.jsx:584
msgid "Edit shortcut"
msgstr "Edita la drecera"

#: src/components/shortcuts-settings.jsx:584
msgid "Add shortcut"
msgstr "Afegeix una drecera"

#: src/components/shortcuts-settings.jsx:620
msgid "Timeline"
msgstr "Línia de temps"

#: src/components/shortcuts-settings.jsx:646
msgid "List"
msgstr "Llista"

#: src/components/shortcuts-settings.jsx:785
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importar/exportar <0>dreceres</0>"

#: src/components/shortcuts-settings.jsx:795
msgid "Import"
msgstr "Importa"

#: src/components/shortcuts-settings.jsx:803
msgid "Paste shortcuts here"
msgstr "Enganxeu dreceres aquí"

#: src/components/shortcuts-settings.jsx:819
msgid "Downloading saved shortcuts from instance server…"
msgstr "S'estan baixant les dreceres desades a la instància del servidor…"

#: src/components/shortcuts-settings.jsx:848
msgid "Unable to download shortcuts"
msgstr "No es poden baixar les dreceres"

#: src/components/shortcuts-settings.jsx:851
msgid "Download shortcuts from instance server"
msgstr "Baixeu les dreceres des de la instància del servidor"

#: src/components/shortcuts-settings.jsx:909
msgid "* Exists in current shortcuts"
msgstr "*Ja existeix a les dreceres actuals"

#: src/components/shortcuts-settings.jsx:914
msgid "List may not work if it's from a different account."
msgstr "És possible que la llista no funcioni si prové d'un compte diferent."

#: src/components/shortcuts-settings.jsx:924
msgid "Invalid settings format"
msgstr "Format de configuració no vàlid"

#: src/components/shortcuts-settings.jsx:932
msgid "Append to current shortcuts?"
msgstr "Voleu afegir-hi les dreceres actuals?"

#: src/components/shortcuts-settings.jsx:935
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Només s'afegiran les dreceres que no existeixen a les dreceres actuals."

#: src/components/shortcuts-settings.jsx:957
msgid "No new shortcuts to import"
msgstr "No hi ha dreceres noves per importar"

#: src/components/shortcuts-settings.jsx:972
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Dreceres importades. S'ha superat el màxim de {SHORTCUTS_LIMIT}, de manera que la resta no s'importaran."

#: src/components/shortcuts-settings.jsx:973
#: src/components/shortcuts-settings.jsx:997
msgid "Shortcuts imported"
msgstr "Dreceres importades"

#: src/components/shortcuts-settings.jsx:983
msgid "Import & append…"
msgstr "Importa i annexa…"

#: src/components/shortcuts-settings.jsx:991
msgid "Override current shortcuts?"
msgstr "Voleu reemplaçar les dreceres actuals?"

#: src/components/shortcuts-settings.jsx:992
msgid "Import shortcuts?"
msgstr "Voleu importar les dreceres?"

#: src/components/shortcuts-settings.jsx:1006
msgid "or override…"
msgstr "o reemplaçar-les…"

#: src/components/shortcuts-settings.jsx:1006
msgid "Import…"
msgstr "Importa…"

#: src/components/shortcuts-settings.jsx:1015
msgid "Export"
msgstr "Exporta"

#: src/components/shortcuts-settings.jsx:1030
msgid "Shortcuts copied"
msgstr "S'han copiat les dreceres"

#: src/components/shortcuts-settings.jsx:1033
msgid "Unable to copy shortcuts"
msgstr "No es poden copiar les dreceres"

#: src/components/shortcuts-settings.jsx:1047
msgid "Shortcut settings copied"
msgstr "S'ha copiat la configuració de la drecera"

#: src/components/shortcuts-settings.jsx:1050
msgid "Unable to copy shortcut settings"
msgstr "No es pot copiar la configuració de la drecera"

#: src/components/shortcuts-settings.jsx:1080
msgid "Share"
msgstr "Comparteix"

#: src/components/shortcuts-settings.jsx:1119
msgid "Saving shortcuts to instance server…"
msgstr "S'estan desant les dreceres a la instància del servidor…"

#: src/components/shortcuts-settings.jsx:1126
msgid "Shortcuts saved"
msgstr "S'han desat les dreceres"

#: src/components/shortcuts-settings.jsx:1131
msgid "Unable to save shortcuts"
msgstr "No es poden desar les dreceres"

#: src/components/shortcuts-settings.jsx:1134
msgid "Sync to instance server"
msgstr "Sincronitza amb la instància del servidor"

#: src/components/shortcuts-settings.jsx:1142
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0 , plural, one {# caràcter} other {# caràcters}}"

#: src/components/shortcuts-settings.jsx:1154
msgid "Raw Shortcuts JSON"
msgstr "Dreceres JSON en brut"

#: src/components/shortcuts-settings.jsx:1167
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importació o exportació de la configuració des de o cap a la instància del servidor (molt experimental)"

#: src/components/status.jsx:463
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>impulsat</1>"

#: src/components/status.jsx:562
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Ho sentim, la instància en què heu iniciat la sessió actual no pot interactuar amb aquesta publicació des d'una altra instància."

#: src/components/status.jsx:715
msgid "Unliked @{0}'s post"
msgstr "La publicació de @{0} s'ha eliminat dels favorits"

#: src/components/status.jsx:716
msgid "Liked @{0}'s post"
msgstr "La publicació de @{0} s'ha afegit als favorits"

#: src/components/status.jsx:755
msgid "Unbookmarked @{0}'s post"
msgstr "La publicació de @{0} s'ha eliminat dels marcadors"

#: src/components/status.jsx:756
msgid "Bookmarked @{0}'s post"
msgstr "La publicació de @{0} s'ha afegit als marcadors"

#: src/components/status.jsx:838
#: src/components/status.jsx:900
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
msgid "Unboost"
msgstr "Desfés l'impuls"

#: src/components/status.jsx:854
#: src/components/status.jsx:2308
msgid "Quote"
msgstr "Cita"

#: src/components/status.jsx:862
#: src/components/status.jsx:2317
msgid "Some media have no descriptions."
msgstr "No tots els mèdia tenen descripció."

#: src/components/status.jsx:869
msgid "Old post (<0>{0}</0>)"
msgstr "Publicacions antigues (<0>{0}</0>)"

#: src/components/status.jsx:888
#: src/components/status.jsx:1340
msgid "Unboosted @{0}'s post"
msgstr "S'ha eliminat l'impuls de la publicació de @{0}"

#: src/components/status.jsx:889
#: src/components/status.jsx:1341
msgid "Boosted @{0}'s post"
msgstr "Heu impulsat la publicació de @{0}"

#: src/components/status.jsx:901
msgid "Boost…"
msgstr "Impulsa…"

#: src/components/status.jsx:913
#: src/components/status.jsx:1625
#: src/components/status.jsx:2338
msgid "Unlike"
msgstr "Ja no m'agrada"

#: src/components/status.jsx:914
#: src/components/status.jsx:1625
#: src/components/status.jsx:1626
#: src/components/status.jsx:2338
#: src/components/status.jsx:2339
msgid "Like"
msgstr "M'agrada"

#: src/components/status.jsx:923
#: src/components/status.jsx:2350
msgid "Unbookmark"
msgstr "Suprimeix l'adreça d'interès"

#: src/components/status.jsx:1031
msgid "View post by <0>@{0}</0>"
msgstr "Mostra la publicació de <0>@{0}</0>"

#: src/components/status.jsx:1052
msgid "Show Edit History"
msgstr "Mostra l'historial d'edició"

#: src/components/status.jsx:1055
msgid "Edited: {editedDateText}"
msgstr "Editat: {editedDateText}"

#: src/components/status.jsx:1122
#: src/components/status.jsx:3078
msgid "Embed post"
msgstr "Insereix la publicació"

#: src/components/status.jsx:1136
msgid "Conversation unmuted"
msgstr "La conversa ha deixat d'estar silenciada"

#: src/components/status.jsx:1136
msgid "Conversation muted"
msgstr "Conversa silenciada"

#: src/components/status.jsx:1142
msgid "Unable to unmute conversation"
msgstr "No s'ha pogut reactivar la conversa"

#: src/components/status.jsx:1143
msgid "Unable to mute conversation"
msgstr "No ha estat possible silenciar la conversa"

#: src/components/status.jsx:1152
msgid "Unmute conversation"
msgstr "Deixa de silenciar la conversa"

#: src/components/status.jsx:1159
msgid "Mute conversation"
msgstr "Silencia la conversa"

#: src/components/status.jsx:1175
msgid "Post unpinned from profile"
msgstr "La publicació ja no està fixada al perfil"

#: src/components/status.jsx:1176
msgid "Post pinned to profile"
msgstr "La publicació s'ha fixat al perfil"

#: src/components/status.jsx:1181
msgid "Unable to unpin post"
msgstr "No s'ha pogut desenganxar la publicació"

#: src/components/status.jsx:1181
msgid "Unable to pin post"
msgstr "No s'ha pogut desenganxar la publicació"

#: src/components/status.jsx:1190
msgid "Unpin from profile"
msgstr "Desfixa del perfil"

#: src/components/status.jsx:1197
msgid "Pin to profile"
msgstr "Fixa al perfil"

#: src/components/status.jsx:1226
msgid "Delete this post?"
msgstr "Voleu suprimir aquesta publicació?"

#: src/components/status.jsx:1239
msgid "Post deleted"
msgstr "Publicació esborrada"

#: src/components/status.jsx:1242
msgid "Unable to delete post"
msgstr "No ha estat possible esborrar la publicació"

#: src/components/status.jsx:1270
msgid "Report post…"
msgstr "Denuncia la publicació…"

#: src/components/status.jsx:1626
#: src/components/status.jsx:1662
#: src/components/status.jsx:2339
msgid "Liked"
msgstr "M'ha agradat"

#: src/components/status.jsx:1659
#: src/components/status.jsx:2326
msgid "Boosted"
msgstr "Millorats"

#: src/components/status.jsx:1669
#: src/components/status.jsx:2351
msgid "Bookmarked"
msgstr "Afegit a marcadors"

#: src/components/status.jsx:1673
msgid "Pinned"
msgstr "Fixat"

#: src/components/status.jsx:1718
#: src/components/status.jsx:2170
msgid "Deleted"
msgstr "Eliminat"

#: src/components/status.jsx:1759
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# resposta} other {# respostes}}"

#: src/components/status.jsx:1848
msgid "Thread{0}"
msgstr "Fil{0}"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
#: src/components/status.jsx:2071
msgid "Show less"
msgstr "Mostra'n menys"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
msgid "Show content"
msgstr "Mostra el contingut"

#: src/components/status.jsx:2071
msgid "Show media"
msgstr "Mostra els mèdia"

#: src/components/status.jsx:2191
msgid "Edited"
msgstr "Editat"

#: src/components/status.jsx:2268
msgid "Comments"
msgstr "Comentaris"

#: src/components/status.jsx:2839
msgid "Edit History"
msgstr "Edita l'Historial"

#: src/components/status.jsx:2843
msgid "Failed to load history"
msgstr "No s'ha pogut carregar l'historial"

#: src/components/status.jsx:2848
msgid "Loading…"
msgstr "Carregant…"

#: src/components/status.jsx:3083
msgid "HTML Code"
msgstr "Codi HTML"

#: src/components/status.jsx:3100
msgid "HTML code copied"
msgstr "Codi HTML copiat"

#: src/components/status.jsx:3103
msgid "Unable to copy HTML code"
msgstr "No ha estat possible copiar el codi HTML"

#: src/components/status.jsx:3115
msgid "Media attachments:"
msgstr "Adjunts multimèdia:"

#: src/components/status.jsx:3137
msgid "Account Emojis:"
msgstr "Emojis d'aquest compte:"

#: src/components/status.jsx:3168
#: src/components/status.jsx:3213
msgid "static URL"
msgstr "URL estàtic"

#: src/components/status.jsx:3182
msgid "Emojis:"
msgstr "Emojis:"

#: src/components/status.jsx:3227
msgid "Notes:"
msgstr "Notes:"

#: src/components/status.jsx:3231
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Això és estàtic, sense estil i sense guió. És possible que hàgiu d'aplicar els vostres propis estils i editar-los segons sigui necessari."

#: src/components/status.jsx:3237
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Les enquestes no són interactives, es converteixen en una llista amb recompte de vots."

#: src/components/status.jsx:3242
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Els mèdia adjunts poden ser imatges, vídeos, àudios o qualsevol altre tipus de fitxer."

#: src/components/status.jsx:3248
msgid "Post could be edited or deleted later."
msgstr "La publicació pot ser editada o eliminada després."

#: src/components/status.jsx:3254
msgid "Preview"
msgstr "Vista prèvia"

#: src/components/status.jsx:3263
msgid "Note: This preview is lightly styled."
msgstr "Nota: a aquesta vista prèvia se li ha aplicat cert estil."

#: src/components/status.jsx:3505
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> ha impulsat"

#: src/components/timeline.jsx:447
#: src/pages/settings.jsx:1048
msgid "New posts"
msgstr "Publicacions noves"

#: src/components/timeline.jsx:548
#: src/pages/home.jsx:212
#: src/pages/notifications.jsx:796
#: src/pages/status.jsx:945
#: src/pages/status.jsx:1318
msgid "Try again"
msgstr "Torna-ho a provar"

#: src/components/timeline.jsx:937
#: src/components/timeline.jsx:944
#: src/pages/catchup.jsx:1860
msgid "Thread"
msgstr "Fil"

#: src/components/timeline.jsx:959
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtrat</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "Traducció automàtica des del {sourceLangText}"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Traducció en procés…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Tradueix des del {sourceLangText} (autodetectat)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Tradueix des del {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Automàtic ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "No s'ha pogut traduir"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "S'està editant la publicació original"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "En resposta a @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Podeu tancar aquesta pàgina ara."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Tanca la finestra"

#: src/compose.jsx:86
msgid "Login required."
msgstr "Cal iniciar sessió."

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:247
msgid "Go home"
msgstr "Ves a la pàgina d'inici"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Publicacions del compte"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Respostes)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Impulsos)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Mèdia)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Neteja els filtres"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Neteja"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Es mostren les publicacions amb respostes"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ Respostes"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Es mostren publicacions sense impulsos"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- Impulsos"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Es mostren les publicacions amb mèdia"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Es mostren les publicacions etiquetades amb #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Es mostren publicacions a {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "No hi ha res a veure encara."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:415
msgid "Unable to load posts"
msgstr "No ha estat possible carregar les publicacions"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "No ha estat possible la informació del compte"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Canvia a la instància del compte {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Canvia a la meva instància (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Mes"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Actual"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Per defecte"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Canvia a aquest compte"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr "Canvia a una pestanya/finestra nova"

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Veure el perfil…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Estableix com a predeterminat"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "Voleu tancar la sessió de <0>@{0}</0>?"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Tanca la sessió…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Afegeix un compte existent"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Nota: el compte <0>Per defecte</0> sempre s'utilitzarà per a la primera càrrega. Si canvieu de compte, aquest es mantindrà obert durant la sessió."

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "No es poden carregar les adreces d'interès."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "l'última hora"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "les últimes 2 hores"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "les últimes 3 hores"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "les últimes 4 hores"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "les últimes 5 hores"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "les últimes 6 hores"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "les últimes 7 hores"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "les últimes 8 hores"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "de les últimes 9 hores"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "les últimes 10 hores"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "les últimes 11 hores"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "les últimes 12 hores"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "més de 12 hores"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Etiquetes seguides"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Grups"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Es mostren {selectedFilterCategory, select, all {totes les publicacions} original {publicacions originals} replies {respostes} boosts {impulsos} followedTags {etiquetes seguides} groups {grups} filtered {publicacions filtrades}}, {sortBy, select, createdAt {{sortOrder, select, asc {més antic} desc {més recent}}} reblogsCount {{sortOrder, select, asc {amb menys impulsos} desc {amb més impulsos}}} favouritesCount {{sortOrder, select, asc {amb menys favorits} desc {amb més favorits}}} repliesCount {{sortOrder, select, asc {amb menys respostes} desc {amb més respostes}}} density {{sortOrder, select, asc {amb menys densitat} desc {amb més densitat}}}} primer{groupBy, select, account {, agrupat per autors} other {}}"

#: src/pages/catchup.jsx:866
#: src/pages/catchup.jsx:890
msgid "Catch-up <0>beta</0>"
msgstr "Posada al dia <0>beta</0>"

#: src/pages/catchup.jsx:880
#: src/pages/catchup.jsx:1552
msgid "Help"
msgstr "Ajuda"

#: src/pages/catchup.jsx:896
msgid "What is this?"
msgstr "Què és això?"

#: src/pages/catchup.jsx:899
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Posada al dia és una línia de temps independent per als vostre seguiments, que ofereix una visió ràpida i precisa, amb una interfície senzilla inspirada en el correu electrònic que permet ordenar i filtrar les publicacions sense esforç."

#: src/pages/catchup.jsx:910
msgid "Preview of Catch-up UI"
msgstr "Vista prèvia de la interfície de Posada al dia"

#: src/pages/catchup.jsx:919
msgid "Let's catch up"
msgstr "Posem-nos al dia"

#: src/pages/catchup.jsx:924
msgid "Let's catch up on the posts from your followings."
msgstr "Poseu-vos al dia amb les publicacions de les persones que segueixes."

#: src/pages/catchup.jsx:928
msgid "Show me all posts from…"
msgstr "Mostra'm totes les publicacions de…"

#: src/pages/catchup.jsx:951
msgid "until the max"
msgstr "fins al màxim"

#: src/pages/catchup.jsx:981
msgid "Catch up"
msgstr "Posada al dia"

#: src/pages/catchup.jsx:987
msgid "Overlaps with your last catch-up"
msgstr "Superposa amb la darrera posada al dia"

#: src/pages/catchup.jsx:999
msgid "Until the last catch-up ({0})"
msgstr "Fins a l'última posada al dia ({0})"

#: src/pages/catchup.jsx:1008
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Nota: la vostra instància només pot mostrar un màxim de 800 publicacions a la línia de temps d'inici, independentment de l'interval de temps. Aquest valor podria variar."

#: src/pages/catchup.jsx:1018
msgid "Previously…"
msgstr "Anteriorment…"

#: src/pages/catchup.jsx:1036
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# publicació} other {# publicacions}}"

#: src/pages/catchup.jsx:1046
msgid "Remove this catch-up?"
msgstr "Voleu eliminar aquesta posada al dia?"

#: src/pages/catchup.jsx:1067
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Nota: només s'emmagatzemaran un màxim de 3. La resta s'eliminarà automàticament."

#: src/pages/catchup.jsx:1082
msgid "Fetching posts…"
msgstr "Recuperant publicacions…"

#: src/pages/catchup.jsx:1085
msgid "This might take a while."
msgstr "Això pot trigar una estona."

#: src/pages/catchup.jsx:1120
msgid "Reset filters"
msgstr "Restableix els filtres"

#: src/pages/catchup.jsx:1128
#: src/pages/catchup.jsx:1558
msgid "Top links"
msgstr "Enllaços populars"

#: src/pages/catchup.jsx:1244
msgid "Shared by {0}"
msgstr "Compartit per {0}"

#: src/pages/catchup.jsx:1283
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr "Totes"

#: src/pages/catchup.jsx:1368
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0 , plural, one {# autor} other {# autors}}"

#: src/pages/catchup.jsx:1380
msgid "Sort"
msgstr "Ordre"

#: src/pages/catchup.jsx:1411
msgid "Date"
msgstr "Data"

#: src/pages/catchup.jsx:1415
msgid "Density"
msgstr "Densitat"

#: src/pages/catchup.jsx:1453
msgid "Authors"
msgstr "Autors"

#: src/pages/catchup.jsx:1454
msgid "None"
msgstr "Cap"

#: src/pages/catchup.jsx:1470
msgid "Show all authors"
msgstr "Mostra tots els autors"

#: src/pages/catchup.jsx:1521
msgid "You don't have to read everything."
msgstr "No cal que ho llegiu tot."

#: src/pages/catchup.jsx:1522
msgid "That's all."
msgstr "Això és tot."

#: src/pages/catchup.jsx:1530
msgid "Back to top"
msgstr "Torna a dalt"

#: src/pages/catchup.jsx:1561
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Enllaços compartits pels vostres seguits, ordenats per recomptes de compartits, impulsos i M'agrada."

#: src/pages/catchup.jsx:1567
msgid "Sort: Density"
msgstr "Ordre: Densitat"

#: src/pages/catchup.jsx:1570
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Les publicacions s'ordenen per densitat o quantitat d'informació. Les publicacions més curtes són \"més lleugeres\" mentre que les publicacions més llargues són \"més pesades\". Les publicacions amb fotos són \"més pesades\" que les publicacions sense fotos."

#: src/pages/catchup.jsx:1577
msgid "Group: Authors"
msgstr "Grup: Autors"

#: src/pages/catchup.jsx:1580
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Les publicacions s'agrupen per autors, ordenades pel nombre de publicacions per autor."

#: src/pages/catchup.jsx:1627
msgid "Next author"
msgstr "Actor següent"

#: src/pages/catchup.jsx:1635
msgid "Previous author"
msgstr "Autor anterior"

#: src/pages/catchup.jsx:1651
msgid "Scroll to top"
msgstr "Torna a dalt"

#: src/pages/catchup.jsx:1842
msgid "Filtered: {0}"
msgstr "Filtrat: {0}"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "No ha estat possible carregar els favorits."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Inici i llistes"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Línies de temps públiques"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Converses"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Perfils"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Mai"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Filtre nou"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0 , plural, one {# filtre} other {# filtres}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "No ha estat possible carregar els filtres."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Encara no hi ha cap filtre."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Afegeix un filtre"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Edita el filtre"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "No ha estat possible editar el filtre"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "No ha estat possible crear el filtre"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Títol"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Paraula sencera"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "No hi ha paraules clau. Afegiu-ne una."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Afegeix una paraula clau"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# paraula clau} other {# paraules clau}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtra des de…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Encara no s'ha implementat"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Status: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Canvia la caducitat"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Caducitat"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "La publicació filtrada serà…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "minimitzada"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "oculta"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Voleu suprimir aquest filtre?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "No ha estat possible esborrar el filtre."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Ha vençut"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "Finalitza en <0/>"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "No caduca mai"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# etiqueta} other {# etiquetes}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "No ha estat possible carregar les etiquetes seguides."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Encara no seguiu cap etiqueta."

#: src/pages/following.jsx:133
msgid "Nothing to see here."
msgstr "No hi ha res a veure ací."

#: src/pages/following.jsx:134
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "No ha estat possible carregar les publicacions."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (només multimèdia) a {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} a {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (només multimèdia)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Ningú ha publicat res encara amb aquesta etiqueta."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "No ha estat possible carregar les publicacions amb aquesta etiqueta"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "Deixa de seguir l'etiqueta #{hashtag}"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "Etiquetes seguides #{hashtag}"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Seguint…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr "No es mostra al perfil"

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr "No s'ha eliminat dels elements destacats del perfil"

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "Destacades al perfil"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "Destaca al perfil"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, one {}other {Màxim de # etiquetes}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Afegeix etiqueta"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Elimina etiqueta"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {S'ha arribat al màxim de # drecera. No es pot afegir un altra.} other {S'ha arribat al màxim de # dreceres. No es pot afegir un altra.}}"

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "Aquesta drecera ja existeix"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "S'ha afegit una drecera a l'etiqueta"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Afegeix a les dreceres"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:444
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Introduïu una nova instància, p. ex. \"mastodon.social\""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:447
msgid "Invalid instance"
msgstr "La instància no és vàlida"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:459
msgid "Go to another instance…"
msgstr "Ves a una altra instància…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:470
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Ves a la meva instància (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:208
msgid "Unable to fetch notifications."
msgstr "No ha estat possible recuperar les notificacions."

#: src/pages/home.jsx:228
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Noves</0> <1>sol·licituds de seguiment</1>"

#: src/pages/home.jsx:234
msgid "See all"
msgstr "Veure-ho tot"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "S'està resolent…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "No es pot resoldre l'URL"

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Encara res."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Gestiona els membres"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "Voleu suprimir a <0>@{0}</0> de la llista?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Suprimeix…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# llista} other {# llistes}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Encara no hi ha cap llista."

#: src/pages/login.jsx:86
#: src/pages/login.jsx:99
msgid "Failed to register application"
msgstr "No s'ha pogut registrar l'aplicació"

#: src/pages/login.jsx:209
msgid "e.g. “mastodon.social”"
msgstr "p. ex. \"mastodont.social\""

#: src/pages/login.jsx:220
msgid "Failed to log in. Please try again or try another instance."
msgstr "No s'ha pogut iniciar la sessió. Torneu-ho a provar o canvieu d'instància."

#: src/pages/login.jsx:232
msgid "Continue with {selectedInstanceText}"
msgstr "Continueu amb {selectedInstanceText}"

#: src/pages/login.jsx:233
msgid "Continue"
msgstr "Continua"

#: src/pages/login.jsx:241
msgid "Don't have an account? Create one!"
msgstr "No hi teniu compte? Creeu-n'hi un!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Mencions privades"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Privat"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Ningú us ha esmentat :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "No ha estat possible carregar les mencions."

#: src/pages/notifications.jsx:97
msgid "You don't follow"
msgstr "No segueixes"

#: src/pages/notifications.jsx:98
msgid "Who don't follow you"
msgstr "Qui no et segueix"

#: src/pages/notifications.jsx:99
msgid "With a new account"
msgstr "Amb un compte nou"

#: src/pages/notifications.jsx:100
msgid "Who unsolicitedly private mention you"
msgstr "Amb menció privada no sol·licitada"

#: src/pages/notifications.jsx:101
msgid "Who are limited by server moderators"
msgstr "Qui està limitat per la moderació del servidor"

#: src/pages/notifications.jsx:523
#: src/pages/notifications.jsx:844
msgid "Notifications settings"
msgstr "Configuració de les notificacions"

#: src/pages/notifications.jsx:541
msgid "New notifications"
msgstr "Notificacions noves"

#: src/pages/notifications.jsx:552
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Anunci} other {Anuncis}}"

#: src/pages/notifications.jsx:599
#: src/pages/settings.jsx:1036
msgid "Follow requests"
msgstr "Sol·licituds de seguiment"

#: src/pages/notifications.jsx:604
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# petició de seguiment} other {# peticions de seguiment}}"

#: src/pages/notifications.jsx:659
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Notificacions filtrades d'# persona} other {Notificacions filtrades de # persones}}"

#: src/pages/notifications.jsx:725
msgid "Only mentions"
msgstr "Només mencions"

#: src/pages/notifications.jsx:729
msgid "Today"
msgstr "Avui"

#: src/pages/notifications.jsx:733
msgid "You're all caught up."
msgstr "Ja les heu vist totes."

#: src/pages/notifications.jsx:756
msgid "Yesterday"
msgstr "Ahir"

#: src/pages/notifications.jsx:792
msgid "Unable to load notifications"
msgstr "No s'han carregat les notificacions"

#: src/pages/notifications.jsx:871
msgid "Notifications settings updated"
msgstr "S’ha actualitzat la configuració de notificacions"

#: src/pages/notifications.jsx:879
msgid "Filter out notifications from people:"
msgstr "Exclou les notificacions de:"

#: src/pages/notifications.jsx:893
msgid "Filter"
msgstr "Filtra"

#: src/pages/notifications.jsx:896
msgid "Ignore"
msgstr "Ignora"

#: src/pages/notifications.jsx:969
msgid "Updated <0>{0}</0>"
msgstr "Actualitzat <0>{0}</0>"

#: src/pages/notifications.jsx:1037
msgid "View notifications from <0>@{0}</0>"
msgstr "Consulteu les notificacions de <0>@{0}</0>"

#: src/pages/notifications.jsx:1058
msgid "Notifications from <0>@{0}</0>"
msgstr "Notificacions de <0>@{0}</0>"

#: src/pages/notifications.jsx:1125
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Les notificacions de @{0} no es filtraran a partir d'ara."

#: src/pages/notifications.jsx:1130
msgid "Unable to accept notification request"
msgstr "No es pot acceptar la sol·licitud de notificació"

#: src/pages/notifications.jsx:1135
msgid "Allow"
msgstr "Permet"

#: src/pages/notifications.jsx:1155
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Les notificacions de @{0} no es mostraran a les Notificacions filtrades a partir d'ara."

#: src/pages/notifications.jsx:1160
msgid "Unable to dismiss notification request"
msgstr "No s'ha pogut descartar la sol·licitud de notificació"

#: src/pages/notifications.jsx:1165
msgid "Dismiss"
msgstr "Ometre"

#: src/pages/notifications.jsx:1180
msgid "Dismissed"
msgstr "Omeses"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Línia de temps local ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Línia de temps federada ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Línia de temps local"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Línia de temps federada"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Ningú ha publicat res encara."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Canvia a federada"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Canvia a local"

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr "Cerca: {q} (publicacions)"

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr "Cerca: {q} (comptes)"

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr "Cerca: {q} (etiquetes)"

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr "Cerca: {q}"

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "Etiquetes"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "Mostra'n més"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "Veure més comptes"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "No s'ha trobat cap compte."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "Veure més etiquetes"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr "No s'ha trobat cap etiqueta."

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "Veure més publicacions"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr "No s'ha trobat cap publicació."

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr "Introduïu el vostre terme de cerca o enganxeu un URL a dalt per començar."

#: src/pages/settings.jsx:74
msgid "Settings"
msgstr "Configuració"

#: src/pages/settings.jsx:83
msgid "Appearance"
msgstr "Aparença"

#: src/pages/settings.jsx:159
msgid "Light"
msgstr "Clar"

#: src/pages/settings.jsx:170
msgid "Dark"
msgstr "Fosc"

#: src/pages/settings.jsx:183
msgid "Auto"
msgstr "Automàtic"

#: src/pages/settings.jsx:193
msgid "Text size"
msgstr "Mida del text"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:198
#: src/pages/settings.jsx:223
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:237
msgid "Display language"
msgstr "Llengua de visualització"

#: src/pages/settings.jsx:246
msgid "Volunteer translations"
msgstr "Ajudeu a traduir"

#: src/pages/settings.jsx:257
msgid "Posting"
msgstr "Publicant"

#: src/pages/settings.jsx:264
msgid "Default visibility"
msgstr "Visibilitat per defecte"

#: src/pages/settings.jsx:265
#: src/pages/settings.jsx:311
msgid "Synced"
msgstr "S'ha sincronitzat"

#: src/pages/settings.jsx:290
msgid "Failed to update posting privacy"
msgstr "No s'ha pogut actualitzar la privadesa de la publicació"

#: src/pages/settings.jsx:313
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Sincronitzat amb la configuració de la instància del servidor. \n"
"<0>Aneu a la vostra instància ({instance}) per realitzar més canvis en la configuració.</0>"

#: src/pages/settings.jsx:328
msgid "Experiments"
msgstr "Experiments"

#: src/pages/settings.jsx:341
msgid "Auto refresh timeline posts"
msgstr "Actualitza automàticament les publicacions de la línia de temps"

#: src/pages/settings.jsx:353
msgid "Boosts carousel"
msgstr "Carrusel d'impulsos"

#: src/pages/settings.jsx:369
msgid "Post translation"
msgstr "Traducció de les publicacions"

#: src/pages/settings.jsx:380
msgid "Translate to"
msgstr "Tradueix a"

#: src/pages/settings.jsx:391
msgid "System language ({systemTargetLanguageText})"
msgstr "Llengua del sistema ({systemTargetLanguageText})"

#: src/pages/settings.jsx:417
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, =0 {Amaga el botó \"Tradueix\" per a:} other {Amaga el botó \"Tradueix\" per a (#):}}"

#: src/pages/settings.jsx:471
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Nota: aquesta funcionalitat utilitza serveis de traducció externs, amb la tecnologia <0>Lingva API</0> i <1>Lingva Translate</1>."

#: src/pages/settings.jsx:505
msgid "Auto inline translation"
msgstr "Traducció automàtica en línia"

#: src/pages/settings.jsx:509
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Mostra automàticament la traducció de les publicacions a la línia de temps. Només funciona per a publicacions <0>breus</0> sense advertència de contingut, contingut multimèdia o enquesta."

#: src/pages/settings.jsx:529
msgid "GIF Picker for composer"
msgstr "Selector de GIF per a compositor"

#: src/pages/settings.jsx:533
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Nota: aquesta funcionalitat utilitza un servei de cerca GIF extern, impulsat per <0>GIPHY</0>. Classificació G (apte per a la visualització per a totes les edats), els paràmetres de seguiment s'eliminen, la informació de referència s'omet de les sol·licituds, però les consultes de cerca i la informació de l'adreça IP encara arribaran als seus servidors."

#: src/pages/settings.jsx:562
msgid "Image description generator"
msgstr "Generador de descripcions d'imatges"

#: src/pages/settings.jsx:567
msgid "Only for new images while composing new posts."
msgstr "Només per a imatges noves mentre es redacten publicacions noves."

#: src/pages/settings.jsx:574
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Nota: aquesta funcionalitat utilitza un servei d'IA extern, impulsat per <0>img-alt-api</0>. Pot ser que no funcioni bé. Només per a imatges i en anglès."

#: src/pages/settings.jsx:600
msgid "Server-side grouped notifications"
msgstr "Notificacions agrupades del servidor"

#: src/pages/settings.jsx:604
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Funcionalitat en fase alfa. Finestra d'agrupació potencialment millorada, però amb una lògica d'agrupació bàsica."

#: src/pages/settings.jsx:625
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "Sincronitza la configuració al núvol"

#: src/pages/settings.jsx:630
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Funcionalitat experimental.<0/>S'emmagatzemen en les notes del perfil propi. Les notes del perfil (privades) s'utilitzen principalment per altres perfils i estan amagades del perfil propi."

#: src/pages/settings.jsx:641
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Nota: Aquesta funcionalitat utilitza l'API del servidor on l'usuari ha iniciat la sessió."

#: src/pages/settings.jsx:658
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Mode ocult <0>(<1>Text</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:667
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Substitueix el text per blocs, útil per prendre captures de pantalla per raons de privacitat."

#: src/pages/settings.jsx:692
msgid "About"
msgstr "Quant a"

#: src/pages/settings.jsx:731
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Creat</0> per <1>@cheeaun</1>"

#: src/pages/settings.jsx:760
msgid "Sponsor"
msgstr "Patrocinadors"

#: src/pages/settings.jsx:768
msgid "Donate"
msgstr "Donacions"

#: src/pages/settings.jsx:776
msgid "Privacy Policy"
msgstr "Política de privadesa"

#: src/pages/settings.jsx:783
msgid "<0>Site:</0> {0}"
msgstr "<0>Lloc web:</0> {0}"

#: src/pages/settings.jsx:790
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Versió:</0> <1/> {0}"

#: src/pages/settings.jsx:805
msgid "Version string copied"
msgstr "Informació de la versió copiada"

#: src/pages/settings.jsx:808
msgid "Unable to copy version string"
msgstr "No s'ha pogut copiar la versió"

#: src/pages/settings.jsx:933
#: src/pages/settings.jsx:938
msgid "Failed to update subscription. Please try again."
msgstr "No s'ha actualitzat la subscripció. Si us plau, intenta-ho de nou."

#: src/pages/settings.jsx:944
msgid "Failed to remove subscription. Please try again."
msgstr "No s'ha eliminat la subscripció. Si us plau, intenta-ho de nou."

#: src/pages/settings.jsx:951
msgid "Push Notifications (beta)"
msgstr "Notificacions (beta)"

#: src/pages/settings.jsx:973
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Les notificacions estan bloquejades. Si us plau, activeu-les al vostre navegador."

#: src/pages/settings.jsx:982
msgid "Allow from <0>{0}</0>"
msgstr "Permet-les de <0>{0}</0>"

#: src/pages/settings.jsx:991
msgid "anyone"
msgstr "qualsevol"

#: src/pages/settings.jsx:995
msgid "people I follow"
msgstr "persones que segueixo"

#: src/pages/settings.jsx:999
msgid "followers"
msgstr "seguidors"

#: src/pages/settings.jsx:1032
msgid "Follows"
msgstr "Seguiments"

#: src/pages/settings.jsx:1040
msgid "Polls"
msgstr "Enquestes"

#: src/pages/settings.jsx:1044
msgid "Post edits"
msgstr "Edició de publicacions"

#: src/pages/settings.jsx:1065
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "No s'ha concedit el permís d'enviar notificacions des del darrer inici de sessió. Haureu d'<0><1>iniciar la sessió</1> de nou per concedir aquest permís</0>."

#: src/pages/settings.jsx:1081
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "NOTA: les notificacions només funcionen per a <0>un compte</0>."

#: src/pages/status.jsx:565
msgid "Post"
msgstr "Publica"

#: src/pages/status.jsx:786
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "No heu iniciat la sessió. Les interaccions (resposta, impuls, etc.) no són possibles."

#: src/pages/status.jsx:799
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Aquesta publicació és d'una altra instància (<0>{instance}</0>). Les interaccions (resposta, impuls, etc.) no són possibles."

#: src/pages/status.jsx:827
msgid "Error: {e}"
msgstr "Error: {e}"

#: src/pages/status.jsx:834
msgid "Switch to my instance to enable interactions"
msgstr "Canvia a la meva instància per permetre interaccions"

#: src/pages/status.jsx:936
msgid "Unable to load replies."
msgstr "No s'han pogut obtenir les respostes."

#: src/pages/status.jsx:1048
msgid "Back"
msgstr "Enrere"

#: src/pages/status.jsx:1079
msgid "Go to main post"
msgstr "Ves a la publicació principal"

#: src/pages/status.jsx:1102
msgid "{0} posts above ‒ Go to top"
msgstr "{0} publicacions més amunt ‒ Ves a la part superior"

#: src/pages/status.jsx:1145
#: src/pages/status.jsx:1208
msgid "Switch to Side Peek view"
msgstr "Canvia a vista lateral"

#: src/pages/status.jsx:1209
msgid "Switch to Full view"
msgstr "Canvia a vista completa"

#: src/pages/status.jsx:1227
msgid "Show all sensitive content"
msgstr "Mostra tot el contingut sensitiu"

#: src/pages/status.jsx:1232
msgid "Experimental"
msgstr "Experimental"

#: src/pages/status.jsx:1241
msgid "Unable to switch"
msgstr "No s'ha pogut canviar"

#: src/pages/status.jsx:1248
msgid "Switch to post's instance ({0})"
msgstr "Canvia a la instància de la publicació ({0})"

#: src/pages/status.jsx:1251
msgid "Switch to post's instance"
msgstr "Canvia a la instància de la publicació"

#: src/pages/status.jsx:1309
msgid "Unable to load post"
msgstr "No ha estat possible carregar la publicació"

#: src/pages/status.jsx:1426
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# resposta} other {<0>{1}</0> respostes}}"

#: src/pages/status.jsx:1444
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# comentari} other {<0>{0}</0> comentaris}}"

#: src/pages/status.jsx:1466
msgid "View post with its replies"
msgstr "Mostra la publicació amb respostes"

#: src/pages/trending.jsx:70
msgid "Trending ({instance})"
msgstr "En tendència ({instance})"

#: src/pages/trending.jsx:227
msgid "Trending News"
msgstr "Ara és tendència"

#: src/pages/trending.jsx:374
msgid "Back to showing trending posts"
msgstr "Torna a les publicacions en tendència"

#: src/pages/trending.jsx:379
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Mostra publicacions mencionant <0>{0}</0>"

#: src/pages/trending.jsx:391
msgid "Trending posts"
msgstr "Publicacions influents"

#: src/pages/trending.jsx:414
msgid "No trending posts."
msgstr "No hi ha publicacions influents."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Un client web per Mastodon minimalista i original."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Inicia sessió amb Mastodon"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "Registreu-vos"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Connecta el teu compte de Mastodon/Fedivers.<0/>Les teves credencials no s'emmagatzemaran en aquest servidor."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Creat</0> per <1>@cheeaun</1>. <2>Política de Privadesa</2>."

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Captura del Carrusel d'impulsos"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Carrusel d'impulsos"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Separeu visualment les publicacions originals de les compartides (impulsos)."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr "Captura de fil de comentaris imbricats"

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr "Fil de comentaris imbricats"

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Seguiu les converses sense esforç. Respostes minimitzades."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr "Captura de les notificacions agrupades"

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Notificacions agrupades"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Les notificacions similars s'agrupen i es contrauen per reduir el desordre."

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Captura de la interfície d'usuari del mode de múltiples columnes"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Única o múltiples columnes"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Per defecte, una única columna per qui busca tranquil·litat. Múltiples columnes configurables per a usuaris avançats."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Captura de la línia de temps de diverses etiquetes amb un formulari per afegir més etiquetes"

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Línia de temps de diverses etiquetes"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Fins a 5 etiquetes combinades en una única línia de temps."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Sembla que el vostre navegador bloca les finestres emergents."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Actualment hi ha un esborrany minimitzat. Publiqueu-lo o descarteu-lo abans de crear-ne un de nou."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Actualment hi ha una publicació oberta. Publiqueu-la o descarteu-la abans de crear-ne una de nova."

